export enum BankaHesapTuru{
    iban = "iban",
    hesap_no = "hesap_no"
}
export enum BankaHesapTuruLabel{
    iban = "IBAN",
    hesap_no = "Hesap Numarası"
}